import { render, staticRenderFns } from "./PrivilegesEdit.vue?vue&type=template&id=647d47f6"
import script from "./PrivilegesEdit.vue?vue&type=script&lang=js"
export * from "./PrivilegesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports